import styled from 'styled-components';
import Heading from 'core/components/Heading';
import { StyleVars, typeScale } from 'core/utils';

const Title = styled(Heading)`
	margin: 0;
	font-weight: 700;
	font-size: 18px;
	letter-spacing: -0.4px;
	margin-bottom: 24px;

	@media(max-width: ${StyleVars.screenSm}) {
		margin-bottom: ${typeScale(2)};
	}
`;

export default Title;
